/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";

const getRows = (data, handleOpenMenu) => {
	const rows = [];
	if (data) {
		data.forEach((item) => {
			rows.push({
				type: (
					<SoftBox
						display="flex"
						alignItems="center"
						sx={{
							cursor: "pointer",
						}}
						data={
							<Icon
								sx={{
									verticalAlign: "middle",
									cursor: "pointer",
									color: getUproColor("uproGreen"),
								}}
								fontSize="lg"
							>
								event
							</Icon>
						}
						onClick={(e) => handleOpenMenu(e, item)}
					>
						<SoftBox pl={3} mr={2}>
							<Tooltip title={"Evento"} placement="top">
								<Icon
									sx={{
										verticalAlign: "middle",
										cursor: "pointer",
										color: getUproColor("uproGreen"),
									}}
									fontSize="lg"
								>
									event
								</Icon>
							</Tooltip>
						</SoftBox>
					</SoftBox>
				),
				id: (
					<SoftBox
						sx={{
							cursor: "pointer",
						}}
						data={item?.id}
						onClick={(e) => handleOpenMenu(e, item)}
					>
						<SoftTypography
							verticalAlign="text-top"
							variant="caption"
							color="dark"
							fontWeight="bold"
						>
							{item?.id}
						</SoftTypography>
					</SoftBox>
				),
				clienteEvento: (
					<SoftBox
						sx={{
							cursor: "pointer",
						}}
						data={makeNiceText(item?.clienteEvento?.nombre)}
						onClick={(e) => handleOpenMenu(e, item)}
					>
						<SoftTypography
							verticalAlign="text-top"
							variant="caption"
							color="dark"
							fontWeight="bold"
						>
							{makeNiceText(item?.clienteEvento?.nombre || item?.clienteEvento?.razonSocial)}
						</SoftTypography>
					</SoftBox>
				),
				nombreEvento: (
					<SoftBox
						sx={{
							cursor: "pointer",
						}}
						data={makeNiceText(item?.nombreEvento)}
						onClick={(e) => handleOpenMenu(e, item)}
					>
						<SoftTypography
							verticalAlign="text-top"
							variant="caption"
							color="dark"
							fontWeight="bold"
						>
							{makeNiceText(item?.nombreEvento)}
						</SoftTypography>
					</SoftBox>
				),
				fecha: (
					<SoftBox
						sx={{
							cursor: "pointer",
						}}
						data={item?.fechaEvento}
						onClick={(e) => handleOpenMenu(e, item)}
					>
						<SoftTypography
							verticalAlign="text-top"
							variant="caption"
							color="dark"
							fontWeight="bold"
						>
							{item?.fechaEvento}
						</SoftTypography>
					</SoftBox>
				),
				estado: (
					<SoftBox
						sx={{
							cursor: "pointer",
						}}
						data={makeNiceText(item?.estado)}
						onClick={(e) => handleOpenMenu(e, item)}
					>
						<SoftBadge
							color={
								item?.estado === "Confirmado"
									? "uproGreen"
									: item?.estado === "Pendiente"
										? "uproYellow"
										: item?.estado === "Cancelado"
											? "uproPink"
											: "secondary"
							}
							badgeContent={makeNiceText(item?.estado) || "-"}
						/>
					</SoftBox>
				),
				accion: (
					<SoftBox
						mr={2}
						gap={1}
						sx={{
							display: "flex",
						}}
					>
						<Tooltip title="Opciones" placement="top">
							<Icon
								sx={{
									verticalAlign: "middle",
									cursor: "pointer",
									color: getUproColor("uproGreen"),
								}}
								fontSize="lg"
								onClick={(e) => handleOpenMenu(e, item)}
							>
								more_vert
							</Icon>
						</Tooltip>
					</SoftBox>
				),
			});
		});
	}
	return rows;
};

const columns = [
	{ name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
	{ name: "id", desc: "ID", width: "1%", align: "left" },
	{ name: "nombreEvento", desc: "Evento", align: "left" },
	{ name: "clienteEvento", desc: "Cliente", align: "left" },
	{ name: "fecha", desc: "Fecha", align: "left" },
	{ name: "estado", desc: "Estado", align: "left" },
	{ name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
